export default "<app-sidenav-cliente></app-sidenav-cliente>"